import script from "./OnboardingAiInviteStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiInviteStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiInviteStep.vue?vue&type=style&index=0&id=8ad751ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ad751ae"]])

export default __exports__